import React from "react";

const Dropdown = ({ id, label, options, valueKey, ...others }) => (
  <>
    <div className="form-group">
        <select id={id} className="form-control" {...others} required>
            <option value="" disabled hidden>{label}</option>
            {options && options.map((option, index) => {
                if (option.name && option.name !== 'Unknown') {
                    return <option value={option[valueKey]} key={`key-${option.id}-${index}`}>{option.name}</option>
                }
                return null;
            })}
        </select>
    </div>
  </>
);

export default Dropdown;
